<div class="container-fluid contentHeight lacourColorUser">
    <div>
        <h1 class="text-center containerTitle">Gestion des comptes clients</h1>
        <nav>
            <div class="nav nav-tabs  bg-light" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-stat0-tab" data-toggle="tab" role="tab" aria-controls="nav-stat0"
                   aria-selected="false" (click)="toggleTab(0, 'nav-stat0','nav-stat0-tab')">En attente</a>
                <a class="nav-item nav-link" id="nav-stat1-tab" data-toggle="tab" role="tab" aria-controls="nav-stat1"
                   aria-selected="false" (click)="toggleTab(1, 'nav-stat1','nav-stat1-tab')">Traité</a>
                <!--<a class="nav-item nav-link" id="nav-stat2-tab" data-toggle="tab" role="tab" aria-controls="nav-stat2"
                   aria-selected="false" (click)="toggleTab(2, 'nav-stat2','nav-stat2-tab')">A contrôler</a>-->
                <!--@caroline -- à supprimer une fois les contrôles de code Unisite terminés-->
            </div>
        </nav>
        <div class="tab-content bg-light adminContent" id="nav-tabContent">
            <div class="row  bg-light noMargin">
                <div class="col-6">
                    <mat-form-field class="ml-2">
                        <mat-label>Rechercher</mat-label>
                        <input matInput (keyup)="applyFilter($event.target.value)">
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <div class="text-right"> <i aria-hidden="true" (click)="refreshTab()" class="fal fa-sync fa-1x5 p-2 pointer"></i> </div>
                </div>
            </div>
            <div class="tab-pane  fade show active" id="nav-stat1" role="tabpanel" aria-labelledby="nav-profile-tab">
                <mat-table class="table lstdossier bg-white table-hover" matSort [dataSource]="colorUserSource" (matSortChange)="sortScale($event,'1')">
                    <!-- Champs Traité -->
                    <ng-container matColumnDef="traite">
                        <mat-header-cell *matHeaderCellDef>Traité</mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            <div *ngIf="user.status == null">
                                <div *ngIf="user.status == null">
                                    <input type="checkbox" id="user.idcolorUser"
                                           (ngModelChange)="onIsCheckedChange(user.idcolorUser)">
                                </div>
                            </div>
                        </mat-cell>
                    </ng-container>
                    <!-- Champs ID -->
                    <ng-container matColumnDef="idcolorUser">
                        <mat-header-cell *matHeaderCellDef>N°</mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            {{user.idcolorUser}}
                        </mat-cell>
                    </ng-container>
                    <!-- Champs Raison Sociale -->
                    <ng-container matColumnDef="companySocialReason">
                        <mat-header-cell *matHeaderCellDef>Raison sociale</mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            {{user.socialReason | uppercase}}
                        </mat-cell>
                    </ng-container>
                    <!-- Champs Adresse -->
                    <ng-container matColumnDef="address">
                        <mat-header-cell *matHeaderCellDef>Adresse</mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            {{user.address | titlecase}} {{user.postalCode}} {{user.city | uppercase}}
                        </mat-cell>
                    </ng-container>
                    <!-- Champs Nom Prénom -->
                    <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef>Nom Prénom</mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            {{user.name | uppercase}} {{user.firstname | titlecase}}
                        </mat-cell>
                    </ng-container>
                    <!-- Champs Pays -->
                    <ng-container matColumnDef="country">
                        <mat-header-cell *matHeaderCellDef>Pays</mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            {{user.country | titlecase}}
                        </mat-cell>
                    </ng-container>
                    <!-- Champs Code Unisite -->
                    <ng-container matColumnDef="unisiteCode">
                        <mat-header-cell *matHeaderCellDef>Code Unisite</mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            {{user.unisiteCode}}
                        </mat-cell>
                    </ng-container>
                    <!-- Champs Mail envoyé -->
                    <ng-container matColumnDef="mailSended">
                        <mat-header-cell *matHeaderCellDef>Mail envoyé</mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            <div *ngIf="user.mailSended == 0">non</div>
                            <div *ngIf="user.mailSended == 1">oui</div>
                        </mat-cell>
                    </ng-container>
                    <!-- Champs Date d'envoi des identifiants -->
                    <ng-container matColumnDef="dateMailSent">
                        <mat-header-cell *matHeaderCellDef>Date envoi identifiants</mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            {{user.dateMailSent}}
                        </mat-cell>
                    </ng-container>
                    <!-- Champs Nombre de connexions -->
                    <ng-container matColumnDef="nbConnection">
                        <mat-header-cell *matHeaderCellDef>Nombre connexions</mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            {{user.nbConnection}}
                        </mat-cell>
                    </ng-container>
                    <!-- Champs Dernière modification -->
                    <ng-container matColumnDef="admin">
                        <mat-header-cell *matHeaderCellDef>Dernière modification</mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            <div>
                                <p class="noMargin">{{user.loginAdmin}}</p>
                                <p class="noMargin" *ngIf="user.dateMajAdmin != null">({{user.dateMajAdmin | date:'dd/MM/yyyy HH:mm'}})</p>
                            </div>
                        </mat-cell>
                    </ng-container>
                    <!-- Champs Editer -->
                    <ng-container matColumnDef="edit">
                        <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            <i aria-hidden="true" class="fal fa-edit fa-1x5 pointer" title="Editer" (click)="displayInfoUser(user)"></i>
                            <i aria-hidden="true" *ngIf="user.statusAdmin == 1" class="fal fa-history fa-1x5 pointer ml-4" title="Voir l'historique" (click)="displayHistory(user)"></i>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                </mat-table>
                <mat-paginator [pageSize]="25" [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons></mat-paginator>

            </div>
        </div>
    </div>
</div>

<!-- Modal - Editer -->
<div id="editModal" class="modal">
    <div class="modal-content" id="editContent" [ngClass]="calculateClasses()" *ngIf="showEditModal">
        <div>
            <div class="col-12 text-center">
                <span class="text-right pointer close" (click)="closeModal('editModal');">
                    <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed "></i>
                </span>
                <h1 class="modal-title"> Informations </h1>
                <hr />
            </div>
            <div class="col-12 mt-3 mb-3">
                <div class="col-12"> <span class="font-weight-bold"> Raison Sociale : </span> {{ currentColorUser.socialReason | uppercase}} </div>
                <div class="col-12"> <span class="font-weight-bold"> Nom : </span> {{ currentColorUser.name | uppercase}} </div>
                <div class="col-12"> <span class="font-weight-bold"> Prénom : </span> {{ currentColorUser.firstname | titlecase}} </div>
                <div class="col-12"> <span class="font-weight-bold"> Adresse : </span> {{currentColorUser.address | titlecase}} {{currentColorUser.postalCode}} {{currentColorUser.city | uppercase}} </div>
                <div class="col-12"> <span class="font-weight-bold"> Pays : </span> {{ currentColorUser.country | titlecase}} </div>
                <div class="col-12"> <span class="font-weight-bold"> Mail : </span> {{ currentColorUser.mail }}     </div>
                <div class="col-12"> <span class="font-weight-bold"> Siret : </span> {{ currentColorUser.siren }}     </div>
                <div class="col-12"> <span class="font-weight-bold"> TVA : </span> {{ currentColorUser.tva }}     </div>
            </div>

            <form [formGroup]="infosUserForm" class="col-12 noMargin mt-4">
                <div class="row col-12">
                    <!--<mat-radio-group formControlName="haveUnisiteCode" class="col-12">
                        <span class="pr-1">Le client a-t-il un code unisite?</span>
                        <mat-radio-button class="ml-2" (change)="userHaveUnisiteCode(true)" (click)="userHaveUnisiteCode(true)" [value]="1">
                            <span>oui</span>
                        </mat-radio-button>
                        <mat-radio-button class="ml-2" (change)="userHaveUnisiteCode(false)" (click)="userHaveUnisiteCode(false)" [value]="0">
                            <span>non</span>
                        </mat-radio-button>
                    </mat-radio-group>-->
                    <mat-form-field class="col-12 col-lg-4 col-md-6 col-sm-6" *ngIf="haveUnisiteCode">
                        <mat-label>Code Unisite</mat-label>
                        <input matInput formControlName="unisiteCode">
                    </mat-form-field>
                </div>
            </form>



            <fieldset class="noMargin row fieldset mt-3" *ngIf="similarColorUser.length > 0">
                <legend></legend>
                <div class="filter">
                    <div class="col-12 mb-2">Nous avons trouvé des clients similaires</div>
                    <table class="table" id="tableSimilarUser" align="center">
                        <caption></caption>
                        <thead>
                            <tr>
                                <th scope="col" style="border: 1px solid #ddd; text-align: center; padding: 1px;">Raison sociale</th>
                                <th scope="col" style="border: 1px solid #ddd; text-align: center; padding: 1px;">Nom Prénom</th>
                                <th scope="col" style="border: 1px solid #ddd; text-align: center; padding: 1px;">Adresse</th>
                                <th scope="col" style="border: 1px solid #ddd; text-align: center; padding: 1px;">Mail</th>
                                <th scope="col" style="border: 1px solid #ddd; text-align: center; padding: 1px;">Téléphone</th>
                                <th scope="col" style="border: 1px solid #ddd; text-align: center; padding: 1px;">Code unisite</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let user of similarColorUser">
                                <td style="border: 1px solid #ddd; text-align: center; padding: 5px;">{{user.socialReason | uppercase}}</td>
                                <td style="border: 1px solid #ddd; text-align: center; padding: 5px;">{{user.name | uppercase}} {{user.firstname | titlecase}}</td>
                                <td style="border: 1px solid #ddd; text-align: center; padding: 5px;">{{user.address | titlecase}} {{user.postalCode}} {{user.city | uppercase}}</td>
                                <td style="border: 1px solid #ddd; text-align: center; padding: 5px;">{{user.mail}}</td>
                                <td style="border: 1px solid #ddd; text-align: center; padding: 5px;">{{user.phone}}</td>
                                <td style="border: 1px solid #ddd; text-align: center; padding: 5px;">{{user.unisiteCode}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </fieldset>




            <div class="row justify-content-center col-12 noMargin mb-3">
                <!--<button *ngIf="currentColorUser.statusAdmin == 0 && !isNewClient" id="btnRegister0N" class="btnRegister btn btn-success col-4 col-lg-2 col-md-2 col-sm-3" (click)="closeModal('editModal');openModal('fusionModal')">Fusionner</button>-->
                <!--<button *ngIf="currentColorUser.statusAdmin == 0 && isNewClient" id="btnRegister0" class="btnRegister btn btn-success col-8 col-lg-4 col-md-6 col-sm-6" (click)="updateUnisiteCodeAndStatus()">Enregistrer et marquer comme traité</button>-->
                <button *ngIf="currentColorUser.statusAdmin == 0 || currentColorUser.statusAdmin == 2" id="btnRegister0" class="btnRegister btn btn-success col-8 col-lg-4 col-md-6 col-sm-6" (click)="updateUnisiteCodeAndStatus()">Enregistrer et marquer comme traité</button>
                <button *ngIf="currentColorUser.statusAdmin == 1" id="btnRegister1" class="btnRegister btn btn-success col-4 col-lg-3 col-md-3 col-sm-3" (click)="updateUnisiteCodeAndStatus()">Enregistrer</button>
            </div>
        </div>
    </div>
</div>

<!--Modal - Historique-->
<div id="histoModal" class="modal">
    <div class="modal-content" id="histoContent">
        <div class="col-12 text-center">
            <span class="text-right pointer close" (click)="closeModal('histoModal');">
                <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed "></i>
            </span>
            <h1 class="modal-title"> Historique des modifications </h1>
        </div>
        <div *ngIf="logInfo.length > 0; else noHisto" class="col-12 mt-3 mb-3">
            <table class="table" id="tableHisto" align="center">
                <caption></caption>
                <thead>
                    <tr>
                        <th scope="col" style="border: 1px solid #ddd; text-align: center; padding: 1px;">Date</th>
                        <th scope="col" style="border: 1px solid #ddd; text-align: center; padding: 1px;">Login</th>
                        <th scope="col" style="border: 1px solid #ddd; text-align: center; padding: 1px;">Code unisite</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let log of logInfo">
                        <td style="border: 1px solid #ddd; text-align: center; padding: 1px;">{{log.logDate | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                        <td style="border: 1px solid #ddd; text-align: center; padding: 1px;">{{log.login}}</td>
                        <td style="border: 1px solid #ddd; text-align: center; padding: 1px;">{{log.infosComp}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <ng-template #noHisto>
            <div class="text-center">Aucun historique disponible.</div>
        </ng-template>
    </div>
</div>
